module.exports = __webpack_public_path__ + "static/media/add-user-to-person.ad3f2906.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/add-user-to-person.jpg
// module id = 1919
// module chunks = 0